/**
 * Invoice numbers on screen come in two series and must sort as one list.
 *
 * Financials issues `YY-XXXX` (per year, since 2026-09-10 — see
 * `backend/src/modules/invoices/invoice-number.ts`, which owns the format);
 * Harvest's imported invoices keep Harvest's plain integers (`1153`). A sort
 * on `Number(number)` put every one of ours at the bottom as NaN. This mirrors
 * the backend's `invoiceNumberSortKey`: ours by year then sequence, Harvest's
 * before them (older), anything else last alphabetically.
 */
const OURS = /^(\d{2})-(\d{4})$/;

export function invoiceNumberSortKey(number: string): number | string {
  const m = OURS.exec(number.trim());
  if (m) return (2000 + Number.parseInt(m[1], 10)) * 10_000 + Number.parseInt(m[2], 10);
  const n = Number.parseInt(number, 10);
  if (Number.isFinite(n) && String(n) === number.trim()) return n;
  return number;
}
